import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { isMobile, isTablet } from "react-device-detect";

import { IReminder } from '../../../store/ReminderStore';
import { setDate } from "../../../../../../includes/util";

interface IProps {
  pageSizeChanged: any;
  pageNoChanged: any;
  addTab: any;
  items: any;
}


const ReminderListItem = (props: IProps) => {

  const { pageSizeChanged, pageNoChanged, addTab } = props;
  const items = props.items.Data;
  const paging = props.items.Paging;

  const onPage = (event: any) => {

    const { page, rows } = event;
    if (Number(paging.PageSize) !== rows) {
      pageSizeChanged(rows);
    }
    else if (Number(paging.PageSize) !== page + 1) {
      pageNoChanged(page + 1);
    }
  };

  const setDetail = (row: IReminder, val: string) => {
    return (
      <span className="info-sub-head cursor-pointer" onClick={() => addTab(row)} >
        <strong className="opt-l-number">
          {val}
        </strong>
      </span>
    );
  };

  const setStatus = (row: IReminder) => {

    let statusClass = "contents-normal";

    if (row.StatusName.toLowerCase() === "overdue") {
      statusClass = "contents-error";
    }
    else if (row.StatusName.toLowerCase() === "duesoon") {
      statusClass = "contents-warning";
    }

    return (
      <span className={`info-sub-head ${statusClass}`}>
        <i title={row.StatusName} className="nc-icon nc-settings"></i>
      </span>
    );

  };

  const setResponsiveContents = (title: string, contents: any, isTitle: boolean = true) => {
    return (
      <>
        {isTitle && <span className="p-column-title">{title}</span>}
        <span className="p-column-content">{contents}</span>
      </>
    );
  };

  const setNumberToLocalString = (val: string | null) => {
    return val || val === "0" ? Number(val).toLocaleString() : "";
  };

  const setNormalDataTable = () => {

    return (
      <DataTable
        rowHover
        style={{ position: "relative" }}
        //size="small"
        value={items}
        className="p-datatable-gridlines  p-datatable-gridlines-custom p-datatable-sm p-datatable-striped p-datatable-striped-custom"
        resizableColumns
        columnResizeMode="fit"
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
        scrollable
        scrollHeight="calc(100vh - 390px)"
      >
        <Column field="AssetPlate" header="Plate" body={(r: IReminder) => setDetail(r, r.AssetPlate)} style={{ width: '130px' }} />
        <Column field="AssetCode" header="Code" body={(r: IReminder) => setDetail(r, r.AssetCode)} style={{ width: '200px' }} />
        <Column field="AssetTypeName" header="Asset Type" body={(r: IReminder) => setDetail(r, r.AssetTypeName)} style={{ width: '200px' }} />
        <Column field="ReminderTypeName" header="Reminder Type" body={(r: IReminder) => setDetail(r, r.ReminderTypeName)} style={{ width: '320px' }} />
        <Column field="CategoryName" header="Category" body={(r: IReminder) => setDetail(r, r.CategoryName)} style={{ width: '180px' }} />
        <Column field="StatusName" header="Status" body={(r: IReminder) => setStatus(r)} style={{ 'textAlign': 'center', width: '80px' }} />
        <Column field="TimeTriggerNextDueDateUtc" header="Next Due Date" body={(r: IReminder) => r.TimeTriggerNextDueDateUtc ? setDate(r.TimeTriggerNextDueDateUtc) : ""} style={{ width: '130px' }} />
        <Column field="OdometerTriggerNextDueOdometerKm" header="Next Due Odo.(km)" body={(r: IReminder) => setNumberToLocalString(r.OdometerTriggerNextDueOdometerKm)} style={{ 'textAlign': 'right', width: '130px' }} />
        <Column field="CurrentOdometerKm" header="Current Odo.(km)" body={(r: IReminder) => setNumberToLocalString(r.CurrentOdometerKm)} style={{ 'textAlign': 'right', width: '150px' }} />
        <Column field="AverageDailyDistanceTravelledKm" header="Average daily usage (km)" body={(r: IReminder) => setNumberToLocalString(r.AverageDailyDistanceTravelledKm)} style={{ 'textAlign': 'right', width: '150px' }} />
        <Column field="EstimatedDateToReachNextDueOdometer" header="Estimated due date" body={(r: IReminder) => r.EstimatedDateToReachNextDueOdometer ? setDate(r.EstimatedDateToReachNextDueOdometer) : ""} style={{ width: '130px' }} />
        <Column field="TimeTriggerLastCompletedDateUtc" header="Last Completed Date" body={(r: IReminder) => r.TimeTriggerLastCompletedDateUtc ? setDate(r.TimeTriggerLastCompletedDateUtc) : ""} style={{ width: '150px' }} />
        <Column field="OdometerTriggerLastCompletedOdometerKm" header="Last Completed odo.(km)" body={(r: IReminder) => setNumberToLocalString(r.OdometerTriggerLastCompletedOdometerKm)} style={{ 'textAlign': 'right', width: '150px' }} />

        <Column field="AssetMake" header="Make" style={{ width: '100px' }} />
        <Column field="AssetModel" header="Model" style={{ width: '100px' }} />
        <Column field="AssetYearOfManufacture" header="Year" style={{ width: '100px' }} />
        <Column field="AssetVin" header="Vin" style={{ width: '200px' }} />

      </DataTable>
    );
  };


  const setResponsiveDataTable = () => {
    return (
      <DataTable
        header='Reminders'
        style={{ position: "relative" }}
        value={items}
        className="p-datatable-responsive p-datatable-sm "
        paginator
        paginatorTemplate="CurrentPageReport  PageLinks  RowsPerPageDropdown"
        currentPageReportTemplate=" {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
      >
        <Column header="Asset" body={(r: IReminder) => setResponsiveContents('Asset', setDetail(r, r.AssetPlate + "-" + r.AssetCode))} />
        <Column header="Asset" body={(r: IReminder) => setResponsiveContents('Asset Type', setDetail(r, r.AssetTypeName))} />
        <Column field="ReminderTypeName" header="ReminderTypeName" body={(r: IReminder) => setResponsiveContents('ReminderType', setDetail(r, r.ReminderTypeName))} />
        <Column field="CategoryName" header="CategoryName" body={(r: IReminder) => setResponsiveContents('Category', setDetail(r, r.CategoryName))} />
        <Column header="Status" body={(r: IReminder) => setResponsiveContents('Status', setStatus(r))} />
      </DataTable>
    );
  };

  const setDataTable = () => {
    if (isMobile && !isTablet) {
      return setResponsiveDataTable();
    }
    else {
      return setNormalDataTable();
    }
  };

  return (
    <>
      <div
        className="perfect-scrollbar"
        style={{ position: "relative", width: "100%", height: "100%" }}
      >
        {setDataTable()}
      </div>

    </>
  );
};

export default ReminderListItem;